<template>
  <div class="background-image">
    <div
      class="background-image-blurred background-image-blurred-left"
      :style="{
        background: `url(${saveDateStore.getImages[ImageType.SAVEDATEFRONT]?.url}) no-repeat center center / cover, ${backgroundColor}`,
      }"
    ></div>
    <div
      class="background-image-blurred background-image-blurred-right"
      :style="{
        background: `url(${saveDateStore.getImages[ImageType.SAVEDATEFRONT]?.url}) no-repeat center center / cover, ${backgroundColor}`,
      }"
    ></div>
    <div class="background-image-main" :style="backgroundStyle"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, toRef, watch, onUnmounted } from 'vue';
import { useStateStore } from '@/stores/state.store';
import { useSaveDateStore } from '@/stores/saveDate/saveDate.store';
import { ImageType } from 'interface/data/image/type';

const stateStore = useStateStore();
const saveDateStore = useSaveDateStore();

const backgroundColor = stateStore.getColors.backgroundColor;

const img = new Image();
const imgBg = toRef(
  () => saveDateStore.getImages[ImageType.SAVEDATEFRONT]?.url,
);

const windowHeight = ref<number>(window.innerHeight);
const imageWidth = ref<number>(1);
const imageHeight = ref<number>(1);

const updateImageSize = () => {
  imageWidth.value = img.width;
  imageHeight.value = img.height;
};

watch(imgBg, (newSrc) => {
  if (newSrc) {
    img.src = newSrc;
  }
});

const backgroundStyle = computed(() => {
  const aspectRatio = imageWidth.value / imageHeight.value;
  const computedWidth = windowHeight.value * aspectRatio * 1.25;

  return {
    width: `${computedWidth}px`,
    height: `${windowHeight.value}px`,
    backgroundImage: `url(${saveDateStore.getImages[ImageType.SAVEDATEFRONT]?.url})`,
  };
});

const handleResize = () => {
  windowHeight.value = window.innerHeight;
};

onMounted(() => {
  img.src = imgBg.value;
  img.onload = updateImageSize;
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});
</script>

<style scoped lang="scss">
.background-image {
  position: absolute;
  width: 100%;
  height: 100%;

  &-blurred {
    position: absolute;
    width: 50%;
    height: 100%;
    filter: blur(75px);
    z-index: 1;
    background-repeat: no-repeat;

    &-left {
      left: 0;
    }

    &-right {
      right: 0;
    }
  }

  &-main {
    position: relative;
    z-index: 2;
    max-width: 100%;
    max-height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 auto;
    mask-image: linear-gradient(
      to right,
      rgb(0 0 0 / 0%) 0%,
      rgb(0 0 0 / 100%) 5%,
      rgb(0 0 0 / 100%) 95%,
      rgb(0 0 0 / 0%) 100%
    );
  }
}
</style>
